export const SUCCESSFUL_NOTIFICATION_SHOWN_KEY = "successfulNotificationShown";
export const SUCCESSFUL_FULLY_VERIFIED_KYC_MESSAGE = "kyc-verify-popup.fully-verified";
export const SUCCESSFUL_FULLY_VERIFIED_KYC_LINK_TEXT = "kyc-verify-popup.deposit";
export const MINOR_ERROR = "MINOR_ERROR";
export const MINOR_ERROR_MAX_UPDATE_DAYS = 30;
export const KYC_NOTIFICATION_VERIFY_NOW = "kyc-verify-popup.existing-kyc-verify-now";
export const KYC_NOTIFICATION_ACCOUNT_WILL_BE_LIMITED = "kyc-verify-popup.existing-kyc-verify-documents";
export const KYC_NOTIFICATION_DOCUMENTS_EXPIRED = "kyc-verify-popup.existing-kyc-verify-update-information";

export const enum DocumentExpiredDaysLeft {
	DOCUMENTS_EXPIRED = 5,
}
